import { useSelector, useDispatch } from 'react-redux';
import FJMobileImageEnhancerCreation from './FJMobileImageEnhancerCreation';
import useLocalStore from '../../../hooks/useLocalStore';
import { useCallback } from 'react';
import FJActionImageEnhancer from '../../../redux/action/FJActionImageEnhancer';

const FJMobileImageEnhancerCreationContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const uploadImageList = useSelector(state => state.imageEnhancer.uploadImageList);
    const imageEnhancerCreationList = useSelector(state => state.imageEnhancer.imageEnhancerCreationList);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const reGenerate = useCallback(
        id => {
            dispatch(FJActionImageEnhancer.reGenerateAction(id));
        },
        [dispatch],
    );
    return (
        <FJMobileImageEnhancerCreation
            uploadImageList={uploadImageList}
            imageEnhancerCreationList={imageEnhancerCreationList}
            taskStatus={taskStatus}
            reGenerate={reGenerate}
        />
    );
};

export default FJMobileImageEnhancerCreationContainer;
